/**
 * paperApi.js — DAS-121 /api/paper/* 호출 헬퍼.
 *
 * 백엔드 (go-server/internal/handler/paper_handler.go) 는 화이트리스트 프록시이며
 * BacktestResearch paper-trader (Mac 로컬 :8088, SSH 리버스 터널) 를 가린다.
 * Mac 다운 시 503 + stale_since 응답 → 호출부에서 stale 판정에 사용.
 */
import apiClient from "./apiClient";
import { kstNow } from "../utils/time";

// 라벨(채택/폐기) 시각 — KST 벽시계 datetime "YYYY-MM-DD HH:mm:ss".
// 이전에는 .slice(0,10) 으로 날짜만 보내 시:분:초가 손실됐다 (DAS-126).
const labeledAtNow = () => kstNow().format("YYYY-MM-DD HH:mm:ss");

export const fetchPaperStrategies = () =>
    apiClient.get("/api/paper/strategies");

export const fetchPaperSummary = () =>
    apiClient.get("/api/paper/summary");

export const fetchPaperPortfolioEquity = (limit = 3000) =>
    apiClient.get("/api/paper/portfolio/equity", { params: { limit } });

export const fetchPaperHealth = () =>
    apiClient.get("/api/paper/health");

export const fetchPaperStrategyTrades = (id, limit = 200) =>
    apiClient.get(`/api/paper/strategy/${encodeURIComponent(id)}/trades`, {
        params: { limit },
    });

export const fetchPaperStrategyPositions = (id) =>
    apiClient.get(`/api/paper/strategy/${encodeURIComponent(id)}/positions`);

// DAS-126 — 전략 폐기(retire) CRUD. paper-trader 프록시와 별개로 go-server 가
// MySQL 에 직접 영속화한다 (read-only 프록시 원칙 유지).
export const fetchPaperRetired = () => apiClient.get("/api/paper/retired");

export const retirePaperStrategy = (id, reason, finalStats) =>
    apiClient.post("/api/paper/retire", {
        id,
        retired_at: labeledAtNow(), // YYYY-MM-DD HH:mm:ss (KST) — 백엔드 labeled_at
        reason,
        final_stats: finalStats ?? null,
    });

export const restorePaperStrategy = (id) =>
    apiClient.delete(`/api/paper/retire/${encodeURIComponent(id)}`);

// DAS-126 — 전략 채택(adopt) CRUD. 폐기와 달리 매매를 중지하지 않고(paper-trader
// 호출 없음) 우수 전략을 북마크한다. 운영 그리드에 ⭐ 배지로 계속 표시된다.
export const fetchPaperAdopted = () => apiClient.get("/api/paper/adopted");

export const adoptPaperStrategy = (id, reason, finalStats) =>
    apiClient.post("/api/paper/adopt", {
        id,
        retired_at: labeledAtNow(), // YYYY-MM-DD HH:mm:ss (KST) — 백엔드 labeled_at
        reason,
        final_stats: finalStats ?? null,
    });

export const unadoptPaperStrategy = (id) =>
    apiClient.delete(`/api/paper/adopt/${encodeURIComponent(id)}`);

// 신규 배지 — go-server 가 기록한 전략 first-seen 시각 조회.
// 응답: [{ strategy_id, first_seen_at(RFC3339 UTC), last_seen_at }]
export const fetchPaperFirstSeen = () => apiClient.get("/api/paper/first-seen");
